import { GraphQLClient } from 'graphql-request'

import { ProfileTranslator } from 'src/translators'
import { ProfileEntity } from 'src/types'
import { getSdk } from 'src/types/generated-request'

export const useGetPromiseProfile = () => {
  const getProfile = async (accessToken: string): Promise<ProfileEntity> => {
    const response = await getSdk(
      new GraphQLClient(process.env.GraphQLUrl ?? '', {
        headers: { 'bearer-token': accessToken },
      })
    ).profile()
    return ProfileTranslator.toEntity(response.profile)
  }

  return {
    getProfile,
  }
}
